import { render, staticRenderFns } from "./PatientFileDeleteDialog.vue?vue&type=template&id=c8d3421c&"
import script from "./PatientFileDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./PatientFileDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports